export function arrayEqual<T>(a1: T[], a2: T[], compareFn?: (a: T, b: T) => number) {
    const a1Sorted = compareFn ? [...a1].sort(compareFn) : a1;
    const a2Sorted = compareFn ? [...a2].sort(compareFn) : a2;
    return JSON.stringify(a1Sorted) === JSON.stringify(a2Sorted);
}

export function prependUniqueNumber({
    numberToPrepend,
    currentArray,
    maxLength,
}: {
    numberToPrepend: number;
    currentArray: number[];
    maxLength: number;
}): number[] {
    return [
        numberToPrepend,
        ...currentArray.filter((currentNumber) => currentNumber !== numberToPrepend),
    ].slice(0, maxLength);
}
